const HttpHeaders = {
  PREVIEW_HEADER: "x-preview",
};

export default HttpHeaders;